// A hairline, not a pill: the surface keeps its pills for the three status
// meanings, and this one only marks where the user stopped reading.
export const ThreadUnreadMarker = () => (
  <div className="flex items-center gap-2 py-1.5">
    <span className="shrink-0 text-xs font-semibold uppercase tracking-wide text-brand-deep">
      New
    </span>
    <span className="h-px flex-1 bg-brand/40" />
  </div>
)
